const routes = [
    {
        path: 'funcionarios-aptos',
        name: 'ListagemFuncionariosAptos',
        component: () => import('./ListagemFuncionariosAptos.vue'),
        children: [
            {
                path: 'funcionarios-aptos/novo',
                name: 'CadastrarFuncionarios',
                component: () => import('./CadastrarFuncionarios.vue'),
                meta: { rules: [''] },
            },
            {
                path: 'funcionarios-aptos/editar/:id',
                name: 'EditarFuncionarioApto',
                component: () => import('./CadastrarFuncionarios.vue'),
                meta: { rules: [''] },
            },
            {
                path: 'funcionarios-aptos/:id',
                name: 'DetalharFuncionarios',
                component: () => import('./DetalharFuncionarios.vue'),
                meta: { rules: [''] },
            },
        ],
        meta: { 
            rules: [''],
            requiredUnidade: 'UNIDADE DE GESTÃO DE PESSOAS'
        },
    },
    
];
export default routes;